import Box from '@mui/material/Box';
import zeplinColor from 'theme/Color';
import SlackFeed from './SlackFeed';

const CommunicationTab = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: { xs: '16px', xl: '24px' },
        height: { xs: 'calc(100vh - 280px)', xl: 'calc(100vh - 380px)' },
      }}
    >
      {/* Left panel */}
      <Box
        sx={{
          flex: 1,
          border: `1px solid ${zeplinColor.Neutral5}`,
          borderRadius: '14px',
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <SlackFeed />
      </Box>

      {/* Right panel */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
        }}
      >
        {/* Upper box */}
        <Box
          sx={{
            flex: 1,
            border: `1px solid ${zeplinColor.Neutral5}`,
            borderRadius: '14px',
            padding: '16px',
          }}
        />

        {/* Lower box */}
        <Box
          sx={{
            flex: 1,
            border: `1px solid ${zeplinColor.Neutral5}`,
            borderRadius: '14px',
            padding: '16px',
          }}
        />
      </Box>
    </Box>
  );
};

export default CommunicationTab;
